module.exports = __webpack_public_path__ + "d80d2d0bcb5c4cc5706121f7516331af.png";